export const STATUS_ADAPTER = {
	open: '1 Abierta',
	close: '2 Cerrada',
};
